import { render } from "./UsuarioSelectDialog.vue?vue&type=template&id=67049961"
import script from "./UsuarioSelectDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioSelectDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__